import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions, cocktailActions } from '../_actions';
import { DeleteButton } from '../DeleteButton';
import { IngredientSlide } from '../IngredientSlide';
import HorizontalScroll from 'react-scroll-horizontal';

class Recipes extends React.Component {
  componentDidMount() {
    this.props.dispatch(cocktailActions.getAllRecipes());
    if (!this.props.ingredients.items) {
      this.props.dispatch(cocktailActions.getAllIngredients());
    }
  }

  render() {
    const { user, recipes, ingredients } = this.props;

    let ingred_array = [];
    if (ingredients && ingredients.items) {
      for (let this_ingredient of ingredients.items) {
        ingred_array.push(this_ingredient.machine_name);
      }
    }

    return (
      <div class="row">
        <div className="col-sm-4 col-md-offset-2">
          <h2>Recipe List Page</h2>
          <p>The dots represent valid ingredients.  Invalid ones display in orange text and would need to be fixed immediately.</p>
          {user.access_level > 5 &&
          <Link to="/add_recipe" className="btn btn-link">Add Recipe</Link>
          }
          {recipes.loading && <em>Loading recipes...</em>}
          {recipes.error && <span className="text-danger">ERROR: {recipes.error}</span>}
          {recipes.items &&
          <div>
            <ol>
              {recipes.items.map((thisRecipe, index) =>
                <li value={thisRecipe.favorites_ct} key={thisRecipe.machine_name}>
                  <Link to={`/recipe/${thisRecipe.machine_name}`}>{thisRecipe.name}</Link>
                  {thisRecipe.ingredients.map((this_recipe_ingred, rec_index) =>
                    <ValidateIngredient ingredient={this_recipe_ingred} all_ingredients={ingred_array} />
                  )}
                  {thisRecipe.measurements && thisRecipe.measurements.map((this_recipe_measurement, meas_index) =>
                    <ValidateMeasurement measurement={this_recipe_measurement} isLast={thisRecipe.measurements.length === (meas_index + 1)}/>
                  )}
                  <DeleteButton item={thisRecipe} user={user} collection={'recipes'}/>
                </li>
              )}
            </ol>

          </div>
          }
        </div>
        <div className="col-sm-4">
          <Route path={`/recipe/:topicId`}
                 render={({match}) => <Recipe match={match} recipes={recipes} ingredients={ingredients} user={user}/>}/>
          <Route exact path="/recipe" render={() => <h3>Please select a recipe.</h3>} />
        </div>
      </div>
    );
  }
}

const ValidateIngredient = ({ingredient, all_ingredients}) => {
  if (all_ingredients.includes(ingredient)) {
    return <span>.</span>
  } else {
    return <div style={{backgroundColor: 'orange'}}>{ingredient} was NOT FOUND!</div>
  }
}

const ValidateMeasurement = ({measurement, isLast}) => {
    return <span>{measurement + (!isLast ? '|' : '')}</span>
}

const Recipe = ({ match, recipes, ingredients, user }) => {
  const machine_name = match.params.topicId

  const isRecipe = p => p.machine_name === machine_name
  let recipe = '';
  if (recipes.items) {
    recipe = recipes.items.find(isRecipe)
  }

  if (!recipe) {
    return <div>Sorry, but the recipe was not found</div>
  }

  if (recipe.img_url.substring(0,4) != 'data') {
    recipe.img_url = 'data:image/png;base64,' + recipe.img_url;
  }

  const parent  = { width: `${(recipe.ingredients.length * 55) - 1}px`, height: `20rem`}

  return (
    <div id="parent">
      <div>
        <h1 id={recipe.machine_name}>{recipe.name}</h1>
        <img src={recipe.img_url}/>
        {user.access_level > 5 &&
        <Link to={`/recipe/${recipe.machine_name}/edit`} className="btn btn-link">Edit</Link>
        }
        <h6>Category:</h6>
        <div dangerouslySetInnerHTML={{__html: recipe.category}} />
        <div>Glassware: {recipe.glassware}</div>
        <div>Get the recipe: <a href={recipe.recipe_url}>{recipe.recipe_url}</a></div>
        <div className="container" id="user_cabinet">

          {ingredients.loading && <em>Loading ingredients...</em>}
          {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
          {ingredients.items && recipe.ingredients &&
          <div style={parent}>
            <HorizontalScroll>
              {recipe.ingredients.map((myIngredient, index) =>
                <IngredientSlide key={myIngredient} match={myIngredient} ingredients={ingredients} linkToIngredient={true}/>
              )}
            </HorizontalScroll>
          </div>
          }

        </div>

      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const { recipes, ingredients, authentication } = state;
  const { user } = authentication;
  return {
    user,
    recipes,
    ingredients
  };
}

const connectedRecipes = connect(mapStateToProps)(Recipes);
export { connectedRecipes as Recipes };


// WEBPACK FOOTER //
// ./src/Recipes/Recipes.jsx